var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSortIcon = function SvgSortIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8 4.5A.75.75 0 1 0 8 3a.75.75 0 0 0 0 1.5ZM8 13a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM3.75 8.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM3.75 4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM3.75 13a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.25 8.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.25 4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.25 13a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    fill: "#64748B",
    stroke: "#64748B",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSortIcon;